function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFieldDef, vgField } from '../../channeldef';
import { GEOJSON } from '../../type';
import * as encode from './encode';
export var geoshape = {
  vgMark: 'shape',
  encodeEntry: function encodeEntry(model) {
    return _objectSpread({}, encode.baseEncodeEntry(model, {
      align: 'ignore',
      baseline: 'ignore',
      color: 'include',
      size: 'ignore',
      orient: 'ignore',
      theta: 'ignore'
    }));
  },
  postEncodingTransform: function postEncodingTransform(model) {
    var encoding = model.encoding;
    var shapeDef = encoding.shape;

    var transform = _objectSpread({
      type: 'geoshape',
      projection: model.projectionName()
    }, shapeDef && isFieldDef(shapeDef) && shapeDef.type === GEOJSON ? {
      field: vgField(shapeDef, {
        expr: 'datum'
      })
    } : {});

    return [transform];
  }
};